module.exports = __webpack_public_path__ + "static/10-b4d2d26b654c242ec73e494245604e8a.png";